import React from 'react'
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv'
import { useAuthContext } from "../whitaijiFrontendLibrary/auth/hooks/useAuthContext"
import { _FETCH } from '../utils/patches'
import { useQuery, useMutationState } from "@tanstack/react-query"
import { AuthContext } from '../context/AuthContext'
// components
import Loading from "../whitaijiFrontendLibrary/components/Loading"
import DocumentDetails from '../components/DocumentDetails'
import DocumentForm from '../components/DocumentForm'
import { useStateContext } from '../context/StateContext'
import {isGodMode, NoAccess} from '../utils/permissions'

  /**
   * The Home page component.
   * 
   * Handles fetching documents data via the "documentsData" query.
   * Handles tracking of mutations in the DocumentForm component
   * via the "mutations" mutation state.
   * 
   * Conditionally renders a loading component while the
   * "documentsData" query is loading.
   * 
   * Conditionally renders a DocumentDetails component for each document
   * in the "documentsData" array.
   * 
   * Conditionally renders a DocumentDetails component with opacity 0.5
   * for each mutation in the "mutations" array.
   * 
   * Always renders a DocumentForm component.
   */
const DocTests = () => {

  const {user} = useAuthContext(AuthContext)

  const {apiUrl} = useStateContext();
  const { data: documentsData, isLoading: documentsDataLoading} = useQuery({
    queryKey: ['documentsData'],
    enabled: !!user,
    queryFn: async () => await _FETCH({route: `${apiUrl}/documents`, user})
  });

    // Tracks the mutations in DocumentForm
    const mutations = useMutationState({
      filters: { mutationKey: ['documentsData'], status: 'pending' },
      select: (mutation) => {
        //process.env.NODE_ENV === "development" && console.log('mutation', mutation)
        return mutation.state.variables}
        
    })
   if (!isGodMode(user)) {
    return <NoAccess />
  } 
  return (
    <div className="home" style={{padding: "30px"}}>
      <div className="documents">
        <VisDiv rules={[documentsDataLoading]}>
          <Loading/>
        </VisDiv>
        <VisDiv rules={[mutations]}>
          {mutations?.map((doc,index) => (
            <div key={index} style={{ opacity: 0.5 }}>
              <DocumentDetails doc={doc} />
            </div>
          ))}
        </VisDiv> 
        <VisDiv rules={[documentsData]}>      
          {documentsData?.map((doc, index) => (
            <div key={doc?._id ? doc?._id : index}>
              <DocumentDetails doc={doc} />
            </div>
          ))}
        </VisDiv>
      </div>
      <DocumentForm />
    </div>
  )
}

export default DocTests